import { render, staticRenderFns } from "./CopydeskSteps.vue?vue&type=template&id=4cdedb9c"
import script from "./CopydeskSteps.vue?vue&type=script&lang=js"
export * from "./CopydeskSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports